import {createContext, useState, useEffect} from "react";

interface DarkModeContext {
    isDarkMode: boolean;
    setDarkMode: (isDarkMode: boolean) => void;
}

export const DarkModeContext = createContext<DarkModeContext | undefined>(undefined);

export function DarkModeContextProvider({children}) {
    const [isDarkMode, setDarkMode] = useState<boolean>(false);

    const setDarkModeAction = (val: boolean) => {
        localStorage.setItem("darkMode", val + "");
        setDarkMode(val);
    };

    useEffect(() => {
        const savedDarkMode = localStorage.getItem("darkMode");
        if (savedDarkMode !== null) {
            setDarkMode(JSON.parse(savedDarkMode));
        }
    }, []);

    const value = {
        setDarkMode: setDarkModeAction,
        isDarkMode: isDarkMode,
    };

    return <DarkModeContext.Provider value={{isDarkMode, setDarkMode}}>{children}</DarkModeContext.Provider>
}
